import { throwError } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { ServiceHandle } from '@tangilla/tg-ng-models/src/lib/types';
import * as i1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { CoreServicesModule } from '@tangilla/tg-ng-core/src/lib/core-services';

class HttpClientService {
    constructor(apiPath, apiType, http, env) {
        this.apiPath = apiPath;
        this.apiType = apiType;
        this.http = http;
        this.env = env;
        this.pathExtension = '';
    }
    setPathExtension(extension) {
        this.pathExtension = `/${extension}`;
    }
    setApiType(apiType) {
        this.apiType = apiType;
    }
    create(body, options) {
        return this.http.post(this.apiURL(), body, options)
            .pipe(this.catchHttpError());
    }
    getOne(id, options) {
        return this.http.get(`${this.apiURL()}/${id}`, options)
            .pipe(this.catchHttpError());
    }
    get(request, url) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : this.apiURL();
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    getAll(request, url, format = true) {
        let options;
        if (request && format) {
            options = { params: request.toHttpParams() };
        }
        else {
            options = request;
        }
        url = url ? url : this.apiURL();
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    getPaginated(request, getAll, url) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : this.apiURL();
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getPaginated(request, getAll, url).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    update(id, body, options) {
        return this.http.put(`${this.apiURL()}/${id}`, body, options)
            .pipe(this.catchHttpError());
    }
    delete(id, params) {
        return this.http.delete(`${this.apiURL()}/${id}`, params ? { params } : undefined)
            .pipe(this.catchHttpError());
    }
    apiURL() {
        return `${this.apiServicePath()}/${this.apiPath}${this.pathExtension}`;
    }
    apiServicePath(serviceHandle) {
        if (this.isServiceHandle('MEMBER_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.MEMBER_SERVICE) {
            return this.env.api.member;
        }
        else if (this.isServiceHandle('ACCOUNT_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.ACCOUNT_SERVICE) {
            return this.env.api.account;
        }
        else if (this.isServiceHandle('COMMITTEE_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.COMMITTEE_SERVICE) {
            return this.env.api.committee;
        }
        else if (this.isServiceHandle('COMMUNICATION_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.COMMUNICATION_SERVICE) {
            return this.env.api.communication;
        }
        else if (this.isServiceHandle('EVENT_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.EVENT_SERVICE) {
            return this.env.api.event;
        }
        else if (this.isServiceHandle('BILLING_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.BILLING_SERVICE) {
            return this.env.api.billing;
        }
        else if (this.isServiceHandle('GOVT_AFFAIRS_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.GOVT_AFFAIRS_SERVICE) {
            return this.env.api.govt;
        }
        else if (this.isServiceHandle('FORMS_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.FORMS_SERVICE) {
            return this.env.api.forms;
        }
        else if (this.isServiceHandle('REPORTING_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.REPORTING_SERVICE) {
            return this.env.api.reporting;
        }
        else if (this.isServiceHandle('UTILITIES_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.UTILITIES_SERVICE) {
            return this.env.api.utilities;
        }
        else if (this.isServiceHandle('EMAIL_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.EMAIL_SERVICE) {
            return this.env.api.email;
        }
        else if (this.isServiceHandle('BEAN_COUNTER_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.BEAN_COUNTER_SERVICE) {
            return this.env.api.bean_counter;
        }
        else if (this.isServiceHandle('STATE_EDUCATION_SERVICE', serviceHandle)
            || this.apiType === ServiceHandle.STATE_EDUCATION_SERVICE) {
            return this.env.api.state_education;
        }
        return '';
    }
    isServiceHandle(serviceHandleName, serviceHandle) {
        return serviceHandle && serviceHandle === ServiceHandle[serviceHandleName];
    }
    catchHttpError() {
        return catchError((error) => {
            if (error && error.status === 400 && error.error) { // Bad request
                return throwError({ userMessage: error.error.message, error });
            }
            else {
                return throwError({ userMessage: 'Something has gone wrong.', error });
            }
        });
    }
}

class PermissibleHttpService {
    constructor(handler) {
        this.handler = handler;
        this.httpClient = new HttpClient(handler);
    }
    get(url, options) {
        return this.httpClient.get(url, options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissibleHttpService, deps: [{ token: i1.HttpBackend }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissibleHttpService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissibleHttpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpBackend }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { HttpClientService, PermissibleHttpService };
